import { render } from "./CategoryActions.vue?vue&type=template&id=6b6ea38b&scoped=true"
import script from "./CategoryActions.vue?vue&type=script&lang=js"
export * from "./CategoryActions.vue?vue&type=script&lang=js"

import "./CategoryActions.vue?vue&type=style&index=0&id=6b6ea38b&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6ea38b"]])

export default __exports__